<template>
  <div>
    <img :src="getUrl()" class="w-[20rem] xl:w-[30rem] 2xl:w-[40rem]" alt="Empty" />
  </div>
</template>

<script lang="ts" setup>
// Store
import { storeToRefs } from "pinia";
import { useSessionStore } from "@store";

const sessionStore = useSessionStore();
const { session } = storeToRefs(sessionStore);

const getUrl = () => {
  if (session.value.lang === "pt") return "/img/TemplatesEmptyImagePT.svg";
  return "/img/TemplatesEmptyImage.svg";
};
</script>
